import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import { connect } from 'react-redux';

// Actions
import { alerts } from 'modules/alerts/actions';

// Services
import Call from 'services/data/call';
import Person from 'services/data/person';

// Components
import SVG from 'components/widgets/icons/svg';


class TransferForm extends React.Component {
  static propTypes = {
    call: PropTypes.shape({
      setOpen: PropTypes.func,
      id: PropTypes.number
    }),
    currentUserId: PropTypes.number,
    users: PropTypes.array
  }

  constructor() {
    super();
    this.transfer = this.transfer.bind(this);
  }

  transfer(userId) {
    Call.transfer(this.props.call.id, userId)
      .then(() => this.props.call.setOpen(false))
      .catch(alerts.catchError);
  }

  render() {
    const { call, users, currentUserId } = this.props;
    const filteredUsers = _.filter(users, Person.isPraece);
    const sortedUsers = _.orderBy(filteredUsers, ['onCall', 'firstName', 'lastName'], ['asc', 'asc', 'asc']);

    return (
      <div className="transfer-form">
        <div className="triage-option-form-header triage-option-header" onClick={() => call.setOpen(false)}>
          <SVG src="svg/transfer.svg" className="transfer triage-option-icon" />
          <span>Transfer</span>
          <SVG src="svg/close.svg" className="close-triage-submenu" />
        </div>
        <ul className="triage-option-submenu transfer-submenu">
          {_.map(sortedUsers, user => {
            if (user.id === currentUserId) return null; // Don't allow transferring to yourself
            return (
              <li
                key={user.id}
                className={classNames({ 'off-call': !user.onCall })}
                onClick={() => this.transfer(user.id)}
              >
                <SVG
                  src={user.onCall ? 'svg/on-call.svg' : 'svg/off-call.svg'}
                  className={classNames('margin-right', { 'on-call': user.onCall, 'off-call': user.offCall })}
                />
                {Person.fullName(user)}
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

export default connect((state) => ({
  currentUserId: state.auth.currentUser.id,
  users: state.pageData.selectUsers
}))(TransferForm);



// WEBPACK FOOTER //
// ./app/components/models/triage/triage-items/triage-options/forms/transfer.js